import EnvironmentConfigPerf from './environmentConfig.perf';
import EnvironmentConfigProdAuth from './environmentConfig.prodauth';
import EnvironmentConfigProd from './environmentConfig.prod';

const getConfigByEnvironment = (environment: string | undefined) => {
  switch (environment) {
    case 'perf':
      return EnvironmentConfigPerf;
    case 'prodauth':
      return EnvironmentConfigProdAuth;
    case 'prod':
      return EnvironmentConfigProd;
    default:
      return EnvironmentConfigProd;
  }
};

export default getConfigByEnvironment;
